import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import PropTypes from "prop-types";
import SettingsIcon from "@mui/icons-material/Settings";

const CNN = "CNN";
const CNNUS = "CNNUS";
const CNBC = "CNBC";
const CNBCUS = "CNBCUS";
const MSNBC = "MSNBC";
const FoxNews = "FoxNews";
const FoxBusiness = "Fox Business";
const Bloomberg = "Bloomberg";
const YAHOO = "YAHOO";
const tableList = [CNN, CNNUS, CNBC, CNBCUS, MSNBC, FoxNews, FoxBusiness, Bloomberg, YAHOO];

const dialogPaperSx = {
  width: "min(92vw, 760px)",
  maxWidth: "760px",
  borderRadius: 3,
};

const dialogContentSx = {
  pt: 1,
  pb: 2,
};

const checkboxGridItemSx = {
  width: "100%",
};

const SettingHeadline = ({ selectedChyrons, setSelectedChyrons }) => {
  const [openSettings, setOpenSettings] = useState(false);
  return (
    <>
      <Tooltip title="Headline setting" arrow>
        <IconButton
          onClick={() => {
            setOpenSettings(true);
          }}
        >
          <SettingsIcon />
        </IconButton>
      </Tooltip>
      <Dialog
        open={openSettings}
        onClose={() => {
          setOpenSettings(false);
        }}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: dialogPaperSx }}
        aria-labelledby="headline-settings-dialog-title"
      >
        <DialogTitle id="headline-settings-dialog-title" sx={{ pb: 1 }}>
          Settings
        </DialogTitle>
        <DialogContent dividers sx={dialogContentSx}>
          <FormControl sx={{ width: "100%" }} component="fieldset" variant="standard">
            <FormLabel component="label" sx={{ mb: 1 }}>
              Show Headline
            </FormLabel>
            <FormGroup>
              <Grid container spacing={2}>
                {tableList.map((item) => (
                  <Grid item key={item} xs={12} sm={6} md={4} sx={checkboxGridItemSx}>
                    <FormControlLabel
                      sx={{ width: "100%", alignItems: "flex-start", m: 0 }}
                      control={
                        <Checkbox
                          checked={selectedChyrons.includes(item)}
                          onChange={() => {
                            let newSelectedTables;
                            if (selectedChyrons.includes(item)) {
                              newSelectedTables = selectedChyrons.filter(
                                (tableName) => tableName != item
                              );
                            } else {
                              newSelectedTables = selectedChyrons.concat(item);
                            }
                            setSelectedChyrons(newSelectedTables);
                            localStorage.setItem("chyronlist", newSelectedTables.join(","));
                          }}
                          name={item}
                        />
                      }
                      label={item}
                    />
                  </Grid>
                ))}
              </Grid>
            </FormGroup>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={() => {
              setOpenSettings(false);
            }}
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

SettingHeadline.propTypes = {
  selectedChyrons: PropTypes.array,
  setSelectedChyrons: PropTypes.func,
};

export default SettingHeadline;
